"use client";
import SectionPage from "@/components/common/section-page";

import {Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList,} from "@/components/ui/breadcrumb";
import CardTitle from "@/components/common/card-title";
import AwesomeCard from "@/components/common/awesome-card";
import CiInteractiveMap, {ciInteractiveMapMarkers,} from "@/components/site-officiel/accueil/ci-interactive-map";
import { useNavigate } from "react-router-dom";
import ImageGallery from "@/components/common/image-gallery";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className={"flex flex-col gap-6 pb-6 bg-slate-100"}>
      <CardTitle
        title={"Nos Régions"}
        backgroundImgSrc={"/images/card-title/Nos-Regions.jpg"}
      />

      {/* Breadcrumb */}
      <SectionPage sectionType="2xl">
        <div className={"flex justify-between items-center"}>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href={"/"}>Nos Régions</BreadcrumbLink>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </SectionPage>

      {/* Présentation */}
      <SectionPage sectionType="2xl">
        <AwesomeCard
          title={"LE SUD : GRAND-BASSAM L’INITIATIVE FAITE FEMME"}
          className={"bg-white text-muted-foreground"}
          titleClassName={"text-bleu-marine"}
        >
          Cette ville pittoresque et son quartier France de type colonial
          inscrite au patrimoine de l’Unesco depuis le 3 juillet 2012, était la
          capitale du pays de 1893 à 1900.
          <br />
          <br />
          En déambulant dans les rues de la ville, vous pourrez : admirer le
          Centre de Céramique dont la bâtisse abritait jadis le Cercle de
          l’Union Européenne haut-lieu de retrouvailles des colons, vous
          recueillir aux pieds de la petite Marianne de Grand-Bassam qui y est
          immortalisée depuis 1914 en hommage aux colons décimés par la peste
          entre 1899 et 1903 et paradoxalement , vous serez admiratif face à la
          fresque et la statue de la marche des femmes d’Abidjan à Bassam contre
          la puissance coloniale pour demander la libération des militants anti
          colonialistes emprisonnés « prémices du leadership des femmes
          Ivoiriennes ».
          <br />
          <br />
          <span className="font-bold"> « Grand-Bassam & les femmes » </span>
        </AwesomeCard>
      </SectionPage>

      {/* galerie */}
      <SectionPage sectionType="2xl">
        <AwesomeCard className={"bg-white"} titleClassName={"text-bleu-marine"}>
          <div className={'mt-1'}>
            <ImageGallery images={
              Array.from({ length: 4 }).map((_, index) => ({
                src: `/images/nos-regions/sud${index + 1}.jpg`,
                alt: `image${index + 1}`,
                width: 700,
                height: 700,
              }))
            } aspectRatio={"video"} />
          </div>
        </AwesomeCard>
      </SectionPage>

      {/* Villes et Régions */}
      <SectionPage sectionType="2xl">
        <AwesomeCard
          title={"Villes et Régions"}
          className={"bg-white text-muted-foreground"}
          titleClassName={"text-bleu-marine"}
        >
          <div className={"flex justify-center w-full"}>
            <CiInteractiveMap
              strokeColor={"#ffffff"}
              markers={ciInteractiveMapMarkers(navigate)}
            />
          </div>
        </AwesomeCard>
      </SectionPage>
    </div>
  );
}
